import { Container, Paper, Typography } from '@material-ui/core';
import React from 'react';
import styles from './NotFound.module.css';

const NotFound: React.FC = () => (
  <Paper className={styles.content}>
    <Container maxWidth="xs">
      <Typography variant="h3" component="h1" gutterBottom>
        404: Not Found
      </Typography>
      <Typography variant="body1">The page you requested does not exist.</Typography>
    </Container>
  </Paper>
);

export default NotFound;
